// import React, { useState, useEffect } from "react";
// import { Card, Form, Button, Modal } from "react-bootstrap";
// import Masonry from "react-responsive-masonry";
// import {
//   getAllBanners,
//   updateBanner,
//   deleteBanner,
//   createBanner,
// } from "api/apis";

// const Banners = () => {
//   const [banners, setBanners] = useState<any[]>([]);
//   const [showModal, setShowModal] = useState(false);
//   const [showDeleteModal, setShowDeleteModal] = useState(false);
//   const [bannerToDelete, setBannerToDelete] = useState<string | null>(null);
//   const [isEditMode, setIsEditMode] = useState(false);
//   const [currentBanner, setCurrentBanner] = useState<any>({
//     title: "",
//     content: "",
//     active: true,
//     image: null,
//     imageUrl: "",
//   });

//   // Fetch all banners on component mount
//   useEffect(() => {
//     fetchBanners();
//   }, []);

//   const fetchBanners = async () => {
//     try {
//       const data = await getAllBanners();
//       setBanners(data);
//     } catch (error) {
//       console.error("Failed to fetch banners", error);
//     }
//   };

//   // Toggle banner active status
//   const handleToggle = async (id: string, currentActive: boolean) => {
//     try {
//       const formData = new FormData();
//       formData.append("active", (!currentActive).toString());

//       await updateBanner(id, formData);

//       setBanners(
//         banners.map((banner) =>
//           banner._id === id ? { ...banner, active: !currentActive } : banner
//         )
//       );
//     } catch (error) {
//       console.error("Failed to update banner status", error);
//     }
//   };

//   // Show delete confirmation modal
//   const confirmDelete = (id: string) => {
//     setBannerToDelete(id);
//     setShowDeleteModal(true);
//   };

//   // Delete a banner after confirmation
//   const handleDelete = async () => {
//     if (!bannerToDelete) return;

//     try {
//       await deleteBanner(bannerToDelete);
//       setBanners(banners.filter((banner) => banner._id !== bannerToDelete));
//       setShowDeleteModal(false);
//       setBannerToDelete(null);
//     } catch (error) {
//       console.error("Failed to delete banner", error);
//     }
//   };

//   // Open modal for editing a banner
//   const handleEdit = (banner: any) => {
//     setIsEditMode(true);
//     setCurrentBanner({
//       ...banner,
//       image: null, // We don't want to overwrite the image unless changed
//     });
//     setShowModal(true);
//   };

//   // Open modal for adding a new banner
//   const handleAddBanner = () => {
//     setIsEditMode(false);
//     setCurrentBanner({
//       title: "",
//       content: "",
//       active: true,
//       image: null,
//       imageUrl: "",
//     });
//     setShowModal(true);
//   };

//   // Handle form input changes
//   const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//     const { name, value, type } = e.target;
//     const checked =
//       type === "checkbox" ? (e.target as HTMLInputElement).checked : undefined;

//     setCurrentBanner({
//       ...currentBanner,
//       [name]: type === "checkbox" ? checked : value,
//     });
//   };

//   // Handle image file selection
//   const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//     if (e.target.files && e.target.files[0]) {
//       setCurrentBanner({
//         ...currentBanner,
//         image: e.target.files[0],
//         imageUrl: URL.createObjectURL(e.target.files[0]),
//       });
//     }
//   };

//   // Submit the form (create or update)
//   const handleSubmit = async () => {
//     try {
//       const formData = new FormData();
//       formData.append("title", currentBanner.title);
//       formData.append("content", currentBanner.content);
//       formData.append("active", currentBanner.active.toString());
//       if (currentBanner.image) {
//         formData.append("image", currentBanner.image);
//       }

//       if (isEditMode && currentBanner._id) {
//         await updateBanner(currentBanner._id, formData);
//       } else {
//         await createBanner(formData);
//       }

//       setShowModal(false);
//       fetchBanners(); // Refresh the list
//     } catch (error) {
//       console.error("Failed to save banner", error);
//     }
//   };

//   return (
//     <div
//       className="container"
//       style={{ marginTop: "8rem", paddingLeft: "2rem" }}
//     >
//       <div className="d-flex justify-content-between mb-4">
//         <h2>Banners Management</h2>
//         <Button variant="primary" onClick={handleAddBanner}>
//           Add New Banner
//         </Button>
//       </div>

//       <Masonry columnsCount={3} gutter="20px">
//         {banners.map((banner) => (
//           <Card key={banner._id} className="mb-3">
//             <Card.Img
//               variant="top"
//               src={banner.imageUrl}
//               style={{ height: "180px", objectFit: "cover" }}
//             />
//             <Card.Body>
//               <Card.Title>{banner.title}</Card.Title>
//               <Card.Text>{banner.content}</Card.Text>

//               <div className="d-flex justify-content-between align-items-center">
//                 <Form.Check
//                   type="switch"
//                   id={`toggle-${banner._id}`}
//                   label={banner.active ? "Active" : "Inactive"}
//                   checked={banner.active}
//                   onChange={() => handleToggle(banner._id, banner.active)}
//                 />

//                 <div>
//                   <button
//                     className="btn btn-sm btn-primary me-2"
//                     onClick={() => handleEdit(banner)}
//                   >
//                     Edit
//                   </button>
//                   <button
//                     className="btn btn-sm btn-danger"
//                     onClick={() => confirmDelete(banner._id)}
//                   >
//                     Delete
//                   </button>
//                 </div>
//               </div>
//             </Card.Body>
//           </Card>
//         ))}
//       </Masonry>

//       {/* Banner Modal */}
//       <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
//         <Modal.Header closeButton>
//           <Modal.Title>
//             {isEditMode ? "Edit Banner" : "Add New Banner"}
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Form>
//             <Form.Group controlId="bannerTitle" className="mb-3">
//               <Form.Label>Title</Form.Label>
//               <Form.Control
//                 type="text"
//                 name="title"
//                 value={currentBanner.title}
//                 onChange={handleInputChange}
//                 placeholder="Enter banner title"
//               />
//             </Form.Group>

//             <Form.Group controlId="bannerContent" className="mb-3">
//               <Form.Label>Content</Form.Label>
//               <Form.Control
//                 as="textarea"
//                 rows={3}
//                 name="content"
//                 value={currentBanner.content}
//                 onChange={handleInputChange}
//                 placeholder="Enter banner content"
//               />
//             </Form.Group>

//             <Form.Group controlId="bannerImage" className="mb-3">
//               <Form.Label>Image</Form.Label>
//               <Form.Control
//                 type="file"
//                 accept="image/*"
//                 onChange={handleImageChange}
//               />
//               {currentBanner.imageUrl && (
//                 <div className="mt-2">
//                   <img
//                     src={currentBanner.imageUrl}
//                     alt="Preview"
//                     style={{ maxHeight: "150px", maxWidth: "100%" }}
//                   />
//                 </div>
//               )}
//             </Form.Group>

//             <Form.Group controlId="bannerActive" className="mb-3">
//               <Form.Check
//                 type="switch"
//                 name="active"
//                 label="Active"
//                 checked={currentBanner.active}
//                 onChange={handleInputChange}
//               />
//             </Form.Group>
//           </Form>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setShowModal(false)}>
//             Cancel
//           </Button>
//           <Button variant="primary" onClick={handleSubmit}>
//             {isEditMode ? "Update" : "Add"} Banner
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Delete Confirmation Modal */}
//       <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
//         <Modal.Header closeButton>
//           <Modal.Title>Confirm Deletion</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           Are you sure you want to delete this banner? This action cannot be
//           undone.
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
//             Cancel
//           </Button>
//           <Button variant="danger" onClick={handleDelete}>
//             Delete
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </div>
//   );
// };

// export default Banners;


// import React, { useState, useEffect } from "react";
// import { Card, Form, Button, Modal, Image, Spinner } from "react-bootstrap";
// import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
// import {
//   getAllBanners,
//   updateBanner,
//   deleteBanner,
//   createBanner,
// } from "api/apis";
// import { toast } from "react-toastify";

// interface Banner {
//   _id: string;
//   title: string;
//   content: string;
//   active: boolean;
//   imageUrl: string;
//   createdAt: string;
//   updatedAt: string;
// }

// const Banners = () => {
//   const [banners, setBanners] = useState<Banner[]>([]);
//   const [loading, setLoading] = useState(true);
//   const [showModal, setShowModal] = useState(false);
//   const [showDeleteModal, setShowDeleteModal] = useState(false);
//   const [bannerToDelete, setBannerToDelete] = useState<string | null>(null);
//   const [isEditMode, setIsEditMode] = useState(false);
//   const [currentBanner, setCurrentBanner] = useState<Partial<Banner>>({
//     title: "",
//     content: "",
//     active: true,
//     imageUrl: "",
//   });
//   const [formData, setFormData] = useState<FormData>(new FormData());
//   const [previewImage, setPreviewImage] = useState<string | null>(null);

//   // Fetch all banners on component mount
//   useEffect(() => {
//     fetchBanners();
//   }, []);

//   const fetchBanners = async () => {
//     try {
//       setLoading(true);
//       const data = await getAllBanners();
//       setBanners(data);
//     } catch (error) {
//       toast.error("Failed to fetch banners");
//       console.error(error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Toggle banner active status
//   const handleToggle = async (id: string, currentActive: boolean) => {
//     try {
//       const formData = new FormData();
//       formData.append("active", (!currentActive).toString());

//       await updateBanner(id, formData);
//       toast.success("Banner status updated");

//       setBanners(
//         banners.map((banner) =>
//           banner._id === id ? { ...banner, active: !currentActive } : banner
//         )
//       );
//     } catch (error) {
//       toast.error("Failed to update banner status");
//       console.error(error);
//     }
//   };

//   // Show delete confirmation modal
//   const confirmDelete = (id: string) => {
//     setBannerToDelete(id);
//     setShowDeleteModal(true);
//   };

//   // Delete a banner after confirmation
//   const handleDelete = async () => {
//     if (!bannerToDelete) return;

//     try {
//       await deleteBanner(bannerToDelete);
//       setBanners(banners.filter((banner) => banner._id !== bannerToDelete));
//       toast.success("Banner deleted successfully");
//       setShowDeleteModal(false);
//       setBannerToDelete(null);
//     } catch (error) {
//       toast.error("Failed to delete banner");
//       console.error(error);
//     }
//   };

//   // Open modal for editing a banner
//   const handleEdit = (banner: Banner) => {
//     setIsEditMode(true);
//     setCurrentBanner(banner);
//     setPreviewImage(banner.imageUrl || null);

//     // Initialize form data
//     const newFormData = new FormData();
//     newFormData.set("title", banner.title);
//     newFormData.set("content", banner.content);
//     newFormData.set("active", banner.active.toString());
//     setFormData(newFormData);

//     setShowModal(true);
//   };

//   // Open modal for adding a new banner
//   const handleAddBanner = () => {
//     setIsEditMode(false);
//     setCurrentBanner({
//       title: "",
//       content: "",
//       active: true,
//       imageUrl: "",
//     });
//     setPreviewImage(null);
//     setFormData(new FormData());
//     setShowModal(true);
//   };

//   // Handle form input changes
//   const handleInputChange = (
//     e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
//   ) => {
//     const { name, value, type } = e.target;
//     const checked =
//       type === "checkbox" ? (e.target as HTMLInputElement).checked : undefined;

//     const newFormData = new FormData();
//     // Copy existing form data
//     // @ts-ignore - FormData doesn't support iteration in TypeScript by default
//     for (let [key, val] of formData.entries()) {
//       newFormData.append(key, val);
//     }

//     if (type === "checkbox") {
//       newFormData.set(name, checked?.toString() || "false");
//     } else {
//       newFormData.set(name, value);
//     }

//     setFormData(newFormData);
//     setCurrentBanner((prev) => ({
//       ...prev,
//       [name]: type === "checkbox" ? checked : value,
//     }));
//   };

//   // Handle image file selection
//   const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//     if (e.target.files && e.target.files[0]) {
//       const file = e.target.files[0];
//       const newFormData = new FormData();

//       // Copy existing form data
//       // @ts-ignore
//       for (let [key, val] of formData.entries()) {
//         newFormData.append(key, val);
//       }

//       newFormData.set("image", file);
//       setFormData(newFormData);

//       setPreviewImage(URL.createObjectURL(file));
//       setCurrentBanner((prev) => ({
//         ...prev,
//         imageUrl: URL.createObjectURL(file),
//       }));
//     }
//   };

//   // Submit the form (create or update)
//   const handleSubmit = async () => {
//     try {
//       if (isEditMode && currentBanner._id) {
//         await updateBanner(currentBanner._id, formData);
//         toast.success("Banner updated successfully");
//       } else {
//         await createBanner(formData);
//         toast.success("Banner created successfully");
//       }

//       setShowModal(false);
//       fetchBanners(); // Refresh the list
//     } catch (error) {
//       toast.error(
//         isEditMode ? "Failed to update banner" : "Failed to create banner"
//       );
//       console.error(error);
//     }
//   };

//   if (loading) {
//     return (
//       <div className="text-center py-5">
//         <Spinner animation="border" variant="primary" />
//         <p className="mt-2">Loading banners...</p>
//       </div>
//     );
//   }

//   return (
//     <div
//       className="container-fluid"
//       style={{ marginTop: "8rem", padding: "0 1rem" }}
//     >
//       <div className="d-flex justify-content-between align-items-center mb-4">
//         <h2>Banners Management</h2>
//         <Button variant="primary" onClick={handleAddBanner}>
//           Add New Banner
//         </Button>
//       </div>

//       {/* Banners Grid */}
//       <ResponsiveMasonry
//         columnsCountBreakPoints={{ 350: 1, 576: 2, 992: 3 }}
//         className="mb-4"
//       >
//         <Masonry gutter="16px">
//           {banners.map((banner) => (
//             <Card key={banner._id} className="mb-3 h-100">
//               <Card.Img
//                 variant="top"
//                 src={banner.imageUrl}
//                 style={{ height: "180px", objectFit: "cover" }}
//               />
//               <Card.Body className="d-flex flex-column">
//                 <Card.Title>{banner.title}</Card.Title>
//                 <Card.Text className="flex-grow-1">{banner.content}</Card.Text>

//                 <div className="d-flex justify-content-between align-items-center mt-auto">
//                   <Form.Check
//                     type="switch"
//                     id={`toggle-${banner._id}`}
//                     label={banner.active ? "Active" : "Inactive"}
//                     checked={banner.active}
//                     onChange={() => handleToggle(banner._id, banner.active)}
//                   />

//                   <div>
//                     <Button
//                       variant="outline-primary"
//                       size="sm"
//                       className="me-2"
//                       onClick={() => handleEdit(banner)}
//                     >
//                       Edit
//                     </Button>
//                     <Button
//                       variant="outline-danger"
//                       size="sm"
//                       onClick={() => confirmDelete(banner._id)}
//                     >
//                       Delete
//                     </Button>
//                   </div>
//                 </div>
//               </Card.Body>
//             </Card>
//           ))}
//         </Masonry>
//       </ResponsiveMasonry>

//       {/* Banner Modal */}
//       <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
//         <Modal.Header closeButton>
//           <Modal.Title>
//             {isEditMode ? "Edit Banner" : "Add New Banner"}
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Form>
//             <Form.Group controlId="bannerTitle" className="mb-3">
//               <Form.Label>Title</Form.Label>
//               <Form.Control
//                 type="text"
//                 name="title"
//                 value={currentBanner.title || ""}
//                 onChange={handleInputChange}
//                 placeholder="Enter banner title"
//               />
//             </Form.Group>

//             <Form.Group controlId="bannerContent" className="mb-3">
//               <Form.Label>Content</Form.Label>
//               <Form.Control
//                 as="textarea"
//                 rows={3}
//                 name="content"
//                 value={currentBanner.content || ""}
//                 onChange={handleInputChange}
//                 placeholder="Enter banner content"
//               />
//             </Form.Group>

//             <Form.Group controlId="bannerImage" className="mb-3">
//               <Form.Label>Image</Form.Label>
//               <Form.Control
//                 type="file"
//                 accept="image/*"
//                 onChange={handleImageChange}
//               />
//               {(previewImage || currentBanner.imageUrl) && (
//                 <div className="mt-2">
//                   <Image
//                     src={previewImage || currentBanner.imageUrl || ""}
//                     alt="Preview"
//                     fluid
//                     className="rounded"
//                     style={{ maxHeight: "200px" }}
//                   />
//                 </div>
//               )}
//             </Form.Group>

//             <Form.Group controlId="bannerActive" className="mb-3">
//               <Form.Check
//                 type="switch"
//                 name="active"
//                 label="Active"
//                 checked={currentBanner.active || false}
//                 onChange={handleInputChange}
//               />
//             </Form.Group>
//           </Form>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setShowModal(false)}>
//             Cancel
//           </Button>
//           <Button variant="primary" onClick={handleSubmit}>
//             {isEditMode ? "Update" : "Add"} Banner
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Delete Confirmation Modal */}
//       <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
//         <Modal.Header closeButton>
//           <Modal.Title>Confirm Deletion</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           Are you sure you want to delete this banner? This action cannot be
//           undone.
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
//             Cancel
//           </Button>
//           <Button variant="danger" onClick={handleDelete}>
//             Delete
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </div>
//   );
// };

// export default Banners;


import React, { useState, useEffect } from "react";
import { Card, Form, Button, Modal, Image, Spinner } from "react-bootstrap";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import {
  getAllBanners,
  updateBanner,
  deleteBanner,
  createBanner,
} from "api/apis";
import { toast } from "react-toastify";

interface Banner {
  _id: string;
  title: string;
  content: string;
  active: boolean;
  images: {
    mobile: string;
    desktop: string;
  };
  createdAt: string;
  updatedAt: string;
}

const Banners = () => {
  const [banners, setBanners] = useState<Banner[]>([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [bannerToDelete, setBannerToDelete] = useState<string | null>(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [currentBanner, setCurrentBanner] = useState<Partial<Banner>>({
    title: "",
    content: "",
    active: true,
    images: {
      mobile: "",
      desktop: "",
    },
  });
  const [formData, setFormData] = useState<FormData>(new FormData());
  const [previewImage, setPreviewImage] = useState<{
    mobile?: string;
    desktop?: string;
  } | null>(null);

  // Fetch all banners on component mount
  useEffect(() => {
    fetchBanners();
  }, []);

  const fetchBanners = async () => {
    try {
      setLoading(true);
      const data = await getAllBanners();
      setBanners(data);
    } catch (error) {
      toast.error("Failed to fetch banners");
      console.error(error);
    } finally {
      setLoading(false);
    }

    console.log("Fetched Banners:", banners);
  };

  // Toggle banner active status
  const handleToggle = async (id: string, currentActive: boolean) => {
    try {
      const formData = new FormData();
      formData.append("active", (!currentActive).toString());

      await updateBanner(id, formData);
      toast.success("Banner status updated");

      setBanners(
        banners.map((banner) =>
          banner._id === id ? { ...banner, active: !currentActive } : banner
        )
      );
    } catch (error) {
      toast.error("Failed to update banner status");
      console.error(error);
    }
  };

  // Show delete confirmation modal
  const confirmDelete = (id: string) => {
    setBannerToDelete(id);
    setShowDeleteModal(true);
  };

  // Delete a banner after confirmation
  const handleDelete = async () => {
    if (!bannerToDelete) return;

    try {
      await deleteBanner(bannerToDelete);
      setBanners(banners.filter((banner) => banner._id !== bannerToDelete));
      toast.success("Banner deleted successfully");
      setShowDeleteModal(false);
      setBannerToDelete(null);
    } catch (error) {
      toast.error("Failed to delete banner");
      console.error(error);
    }
  };

  // Open modal for editing a banner
  const handleEdit = (banner: Banner) => {
    setIsEditMode(true);
    setCurrentBanner(banner);
    setPreviewImage({
      mobile: banner.images.mobile,
      desktop: banner.images.desktop,
    });

    // Initialize form data
    const newFormData = new FormData();
    newFormData.set("title", banner.title);
    newFormData.set("content", banner.content);
    newFormData.set("active", banner.active.toString());
    setFormData(newFormData);

    setShowModal(true);
  };

  // Open modal for adding a new banner
  const handleAddBanner = () => {
    setIsEditMode(false);
    setCurrentBanner({
      title: "",
      content: "",
      active: true,
      images: {
        mobile: "",
        desktop: "",
      },
    });
    setPreviewImage(null);
    setFormData(new FormData());
    setShowModal(true);
  };

  // Handle form input changes
  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value, type } = e.target;
    const checked =
      type === "checkbox" ? (e.target as HTMLInputElement).checked : undefined;

    const newFormData = new FormData();
    // Copy existing form data
    Array.from(formData.entries()).forEach(([key, val]) => {
      newFormData.append(key, val);
    });

    if (type === "checkbox") {
      newFormData.set(name, checked?.toString() || "false");
    } else {
      newFormData.set(name, value);
    }

    setFormData(newFormData);
    setCurrentBanner((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  // Handle image file selection
  const handleImageChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    imageType: "mobile" | "desktop"
  ) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      const newFormData = new FormData();

      // Copy existing form data
      Array.from(formData.entries()).forEach(([key, val]) => {
        newFormData.append(key, val as any);
      });

      // Append file with appropriate field name based on image type
      newFormData.append(imageType === "mobile" ? "mobileImage" : "desktopImage", file);
      setFormData(newFormData);

      const imageUrl = URL.createObjectURL(file);
      setPreviewImage((prev) => ({
        ...prev,
        [imageType]: imageUrl,
      }));

      setCurrentBanner((prev) => ({
        ...prev,
        images: {
          ...prev.images!,
          [imageType]: imageUrl,
        },
      }));
    }
  };

  // Submit the form (create or update)
  const handleSubmit = async () => {
    try {
      if (isEditMode && currentBanner._id) {
        await updateBanner(currentBanner._id, formData);
        toast.success("Banner updated successfully");
      } else {
        await createBanner(formData);
        toast.success("Banner created successfully");
      }

      setShowModal(false);
      fetchBanners(); // Refresh the list
    } catch (error) {
      toast.error(
        isEditMode ? "Failed to update banner" : "Failed to create banner"
      );
      console.error(error);
    }
  };

  if (loading) {
    return (
      <div className="text-center py-5">
        <Spinner animation="border" variant="primary" />
        <p className="mt-2">Loading banners...</p>
      </div>
    );
  }

  return (
    <div
      className="container-fluid"
      style={{ marginTop: "8rem", padding: "0 1rem" }}
    >
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2>Banners Management</h2>
        <Button variant="primary" onClick={handleAddBanner}>
          Add New Banner
        </Button>
      </div>

      {/* Banners Grid */}
      <ResponsiveMasonry
        columnsCountBreakPoints={{ 350: 1, 576: 2, 992: 3 }}
        className="mb-4"
      >
        <Masonry gutter="16px">
          {banners.map((banner) => (
            <Card key={banner._id} className="mb-3 h-100">
              <div style={{ position: "relative" }}>
                <Card.Img
                  variant="top"
                  src={banner.images.desktop || banner.images.mobile}
                  style={{ height: "180px", objectFit: "cover" }}
                />
                <div
                  style={{
                    position: "absolute",
                    top: "5px",
                    right: "5px",
                    backgroundColor: "rgba(0,0,0,0.5)",
                    color: "white",
                    padding: "2px 8px",
                    borderRadius: "3px",
                    fontSize: "12px",
                  }}
                >
                  Desktop
                </div>
              </div>
              <Card.Body className="d-flex flex-column">
                <Card.Title>{banner.title}</Card.Title>
                <Card.Text className="flex-grow-1">{banner.content}</Card.Text>

                <div className="d-flex justify-content-between align-items-center mt-auto">
                  <Form.Check
                    type="switch"
                    id={`toggle-${banner._id}`}
                    label={banner.active ? "Active" : "Inactive"}
                    checked={banner.active}
                    onChange={() => handleToggle(banner._id, banner.active)}
                  />

                  <div>
                    <Button
                      variant="outline-primary"
                      size="sm"
                      className="me-2"
                      onClick={() => handleEdit(banner)}
                    >
                      Edit
                    </Button>
                    <Button
                      variant="outline-danger"
                      size="sm"
                      onClick={() => confirmDelete(banner._id)}
                    >
                      Delete
                    </Button>
                  </div>
                </div>
              </Card.Body>
            </Card>
          ))}
        </Masonry>
      </ResponsiveMasonry>

      {/* Banner Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>
            {isEditMode ? "Edit Banner" : "Add New Banner"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="bannerTitle" className="mb-3">
              <Form.Label>Title</Form.Label>
              <Form.Control
                type="text"
                name="title"
                value={currentBanner.title || ""}
                onChange={handleInputChange}
                placeholder="Enter banner title"
              />
            </Form.Group>

            <Form.Group controlId="bannerContent" className="mb-3">
              <Form.Label>Content</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                name="content"
                value={currentBanner.content || ""}
                onChange={handleInputChange}
                placeholder="Enter banner content"
              />
            </Form.Group>

            <Form.Group controlId="desktopImage" className="mb-3">
              <Form.Label>Desktop Image</Form.Label>
              <Form.Control
                type="file"
                accept="image/*"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  handleImageChange(e, "desktop")
                }
              />
              {(previewImage?.desktop || currentBanner.images?.desktop) && (
                <div className="mt-2">
                  <Image
                    src={
                      previewImage?.desktop ||
                      currentBanner.images?.desktop ||
                      ""
                    }
                    alt="Desktop Preview"
                    fluid
                    className="rounded"
                    style={{ maxHeight: "200px" }}
                  />
                </div>
              )}
            </Form.Group>

            <Form.Group controlId="mobileImage" className="mb-3">
              <Form.Label>Mobile Image</Form.Label>
              <Form.Control
                type="file"
                accept="image/*"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  handleImageChange(e, "mobile")
                }
              />
              {(previewImage?.mobile || currentBanner.images?.mobile) && (
                <div className="mt-2">
                  <Image
                    src={
                      previewImage?.mobile ||
                      currentBanner.images?.mobile ||
                      ""
                    }
                    alt="Mobile Preview"
                    fluid
                    className="rounded"
                    style={{ maxHeight: "200px" }}
                  />
                </div>
              )}
            </Form.Group>

            <Form.Group controlId="bannerActive" className="mb-3">
              <Form.Check
                type="switch"
                name="active"
                label="Active"
                checked={currentBanner.active || false}
                onChange={handleInputChange}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSubmit}>
            {isEditMode ? "Update" : "Add"} Banner
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Delete Confirmation Modal */}
      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Deletion</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete this banner? This action cannot be
          undone.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleDelete}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Banners;